import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Se il caricamento è in corso, mostra un caricamento
  if (loading) {
    return <div>Caricamento...</div>;
  }

  // Se non c'è utente, reindirizza al login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se l'utente è autenticato, mostra i componenti figli
  return children;
};

export default PrivateRoute; 